import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { NbWindowService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { map } from 'rxjs/operators';
import { DishGalleryWindowContext } from '../dish-images-templates/dish-gallery-window-context';
import { DishImagesTemplatesComponent } from '../dish-images-templates/dish-images-templates.component';

@Component({
    selector: 'ngx-file-uploader',
    templateUrl: 'file-uploader.component.html',
    styleUrls: ['file-uploader.component.scss'],
    inputs: ['activeColor', 'baseColor', 'overlayColor'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FileUploaderComponent
        }
    ],
    standalone: false
})
export class FileUploaderComponent extends OnDestroyMixin implements ControlValueAccessor {
    private reader: FileReader = new FileReader();

    @Input()
    showGalleryButton = true;

    constructor(
        private ref: ChangeDetectorRef,       
        private translate: TranslateService,
        private windowService: NbWindowService)
    {
        super();
        this.reader.onload = (e) => {
            this.markAsTouched();
            console.log("_handleReaderLoaded")
            this.imageSrc = this.reader.result as string;
            this.loaded = true;
            this.ref.detectChanges();
            this.onChange(this.imageSrc);
        };
    }

    writeValue(value: any): void {
        if (!value)
            value = '';
        this.imageSrc = value;
    }
    registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }
    registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }
    setDisabledState?(disabled: boolean): void {
        this.disabled = disabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    onChange = (url) => {};
    onTouched = () => {};
    touched = false;
    disabled = false;

    activeColor: string = 'green';
    baseColor: string = '#ccc';
    overlayColor: string = 'rgba(255,255,255,0.5)';
    iconColor: string = 'rgba(255,255,255,0.5)';
    borderColor: string = 'rgba(255,255,255,0.5)';
    
    dragging: boolean = false;
    loaded: boolean = false;
    imageLoaded: boolean = false;
    imageSrc: string = '';
    
    handleDragEnter() {
        console.log("handleDragEnter")
        this.dragging = true;
    }
    
    handleDragLeave() {
         console.log("handleDragLeave")
        this.dragging = false;
    }
    
    handleDrop(e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    }
    
    handleImageLoad() {
        this.imageLoaded = true;
        this.iconColor = this.overlayColor;
    }

    handleInputChange(e) {
        console.log("input change")
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

        var pattern = /image-*/;

        if (!file.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        
        this.loaded = false;
        this.reader.readAsDataURL(file);
    }
        
    _setActive() {
        this.borderColor = this.activeColor;
        if (this.imageSrc.length === 0) {
            this.iconColor = this.activeColor;
        }
    }
    
    _setInactive() {
        this.borderColor = this.baseColor;
        if (this.imageSrc.length === 0) {
            this.iconColor = this.baseColor;
        }
    }
    
    cancel(){
        this.loaded = false;
        this.imageSrc="";
        this.markAsTouched();
        this.onChange("");
    }
    
    openDefaultImagesWindow(event) {
        event.preventDefault();

        const context = new DishGalleryWindowContext();
        context.onImageSelected.pipe(untilComponentDestroyed(this)).subscribe(value => {
            this.markAsTouched();
            this.imageSrc = value;
            this.loaded = true;
            this.ref.detectChanges();
            this.onChange(this.imageSrc);
        });

        this.translate.get(marker('dishes_gallery_window_title')).pipe(
            map(title =>
              this.windowService.open(DishImagesTemplatesComponent, {
                title: title, 
                hasBackdrop: true, closeOnBackdropClick: false, windowClass: 'app-window-modal',
                context: context
              })
            ),
            untilComponentDestroyed(this)
          ).subscribe();
    }
}
    